<template lang="html">
    <div>
        <span class="name" v-if="showName">Tarih</span>
        <div class="daterange">
            <i class="fa fa-calendar"></i>&nbsp;{{selectedDate}} <b class="caret"></b>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import 'bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
moment.locale('tr');

export default {
    props: {
        dateRange: {
            type: Array,
            required: true
        },
        opens: {
            type: String,
            default: 'left',
            required: false
        },
        dateFormat: {
            type: String,
            default: 'DD.MM.YYYY',
            required: false
        },
        showName: {
            type: Boolean,
            default: true,
            required: false
        },
        singleDatePicker: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    data: function () {
        return {
            selectedStartDate: this.dateRange[0],
            selectedEndDate: this.dateRange[1]
        }
    },
    mounted: function () {
        var $this = this;
        var todayRange = [moment(), moment()];
        var yesterdayRange = [moment().subtract(1, 'days'), moment().subtract(1, 'days')];
        var last7Days = [moment().subtract(6, 'days'), moment()];
        var last30Days = [moment().subtract(29, 'days'), moment()];
        var thisMonth = [moment().startOf('month'), moment().endOf('month')];
        var pastMonth = [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')];
        $(this.$el).daterangepicker({
            locale: {
                format: this.dateFormat,
                applyLabel: 'Uygula',
                cancelLabel: 'İptal',
                customRangeLabel: 'Özel',
                firstDay: 1
            },
            singleDatePicker: this.singleDatePicker,
            showDropdowns: true,
            alwaysShowCalendars: true,
            opens: this.opens,
            startDate: this.startDate,
            endDate: this.endDate,
            minDate: moment().subtract(2, 'year'),
            maxDate: moment(),
            ranges: {
                'Bugün': todayRange,
                'Dün': yesterdayRange,
                'Son 1 Hafta': last7Days,
                'Son 30 Gün': last30Days,
                'Bu Ay': thisMonth,
                'Geçen Ay': pastMonth
            }
        }, function (startDate, endDate) {
            $this.selectedStartDate = startDate;
            $this.selectedEndDate = endDate;
            $this.$emit('onChange', [startDate, endDate]);
        });
    },
    computed: {
        selectedDate: function () {
            return this.selectedStartDate.format(this.dateFormat) + ' - ' + this.selectedEndDate.format(this.dateFormat);
        }
    }
}
</script>

<style scoped>
    span.name {
        font-size: 12px;
    }

    .daterange {
        background: #fff;
        cursor: pointer;
        padding: 5px 10px;
        border: 1px solid #ccc;
        -moz-border-radius: 4px;
        -webkit-border-radius: 4px;
        border-radius: 4px;
        width: 100%;
        font-size: 12px;
    }
</style>



// WEBPACK FOOTER //
// daterange.vue?05360ec0